import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { DatasetRead } from "@/types/datasets";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

interface GetDatasetsResponse {
  success: boolean;
  message: string;
  datasets: (DatasetRead & { dataset_name: string })[];
  has_prev: boolean;
  has_next: boolean;
  prev_num: number | null;
  next_num: number | null;
  page: number;
  pages: number;
  per_page: number;
  total: number;
}

interface GetDatasetsParams {
  workspace_id: number;
  prompt_id?: number;
  page?: number;
  per_page?: number;
}

export const useDatasetsByPromptId = (params: GetDatasetsParams) => {
  const { workspace_id, prompt_id, page = 1, per_page = 10 } = params;
  const userToken = useUserToken();

  return useQuery<GetDatasetsResponse>({
    queryKey: ["datasets", workspace_id, prompt_id, page, per_page],
    queryFn: () => {
      const url = new URL(ENDPOINTS.get_datasets(workspace_id));

      if (prompt_id) {
        url.searchParams.append("prompt_id", prompt_id.toString());
      }

      url.searchParams.append("page", page.toString());
      url.searchParams.append("per_page", per_page.toString());

      return fetch(url.toString(), {
        method: "GET",
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
    enabled: !!workspace_id,
  });
};
